import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

const WebsiteDevelopment = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    Website <span className="breadcrumb-highlight">Development</span>
                                </h1>
                                <Link to="/services" style={{ textDecoration: 'none' }}>
                                    <button className="breadcrumb-btn">
                                        <span>Our Services</span>
                                        <span className="breadcrumb-arrow">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Hero Section - New Design */}
            <section className="digital-presence-hero">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="hero-badge">
                                <span className="badge-dot"></span>
                                Award-Winning Web Design Agency
                            </div>
                            <h2 className="intro-about-heading">
                                Elevate Your
                                <span className="text-gradient"> Digital Presence</span>
                            </h2>
                            <p className="hero-description color-change-dark">
                                Transform your brand with cutting-edge web design that combines <span className="text-blue-highlight">stunning aesthetics</span> with <span className="text-green-highlight">powerful functionality.</span>
                            </p>
                            <div className="hero-buttons">
                                {/* <button className="btn-hero-primary">
                                    Start Your Project
                                </button> */}
                                <button className="btn-hero-secondary">
                                    View Portfolio →
                                </button>
                            </div>
                            <div className="hero-stats">
                                <div className="stat-card">
                                    <h3 className="stat-number">250+</h3>
                                    <p className="stat-label">Projects Delivered</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">98%</h3>
                                    <p className="stat-label">Client Satisfaction</p>
                                </div>
                                <div className="stat-card">
                                    <h3 className="stat-number">8+</h3>
                                    <p className="stat-label">Years Experience</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="hero-image-container">
                                <div className="hero-main-screen">
                                    <div className="screen-header">
                                        <span className="dot dot-red"></span>
                                        <span className="dot dot-yellow"></span>
                                        <span className="dot dot-green"></span>
                                    </div>
                                    <div className="screen-content">
                                        <div className="screen-split">
                                            <div className="screen-left">
                                                <div className="code-editor">
                                                    <div className="code-line"></div>
                                                    <div className="code-line short"></div>
                                                    <div className="code-line"></div>
                                                    <div className="code-line medium"></div>
                                                    <div className="code-line"></div>
                                                    <div className="code-line short"></div>
                                                </div>
                                            </div>
                                            <div className="screen-right">
                                                <div className="preview-content">
                                                    <h4>Digital Products</h4>
                                                    <div className="preview-cards">
                                                        <div className="preview-card"></div>
                                                        <div className="preview-card"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="hero-tablet-screen">
                                    <div className="tablet-content">
                                        <div className="chart-preview"></div>
                                    </div>
                                </div>
                                <div className="hero-phone-screen">
                                    <div className="phone-content"></div>
                                </div>
                                <div className="floating-icon icon-bulb">
                                    💡
                                </div>
                                <div className="floating-icon icon-palette">
                                    🎨
                                </div>
                                <div className="hero-plant"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Comprehensive Design Solutions Section */}
            <section className="comprehensive-design-section py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="expertise-badge">
                            Our Expertise
                        </div>
                        <h2 className="comprehensive-title">
                            Comprehensive Design Solutions
                        </h2>
                        <p className="comprehensive-subtitle">
                            Everything you need to create a stunning digital presence
                        </p>
                    </div>

                    <div className="row g-4">
                        {/* Custom Design */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎨</span>
                                </div>
                                <h3 className="solution-card-title">Custom Design</h3>
                                <p className="solution-card-description">
                                    Unique website designs tailored to your brand identity and business objectives
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Responsive Design */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">📱</span>
                                </div>
                                <h3 className="solution-card-title">Responsive Design</h3>
                                <p className="solution-card-description">
                                    Seamless experiences across all devices - mobile, tablet, and desktop
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* UI/UX Design */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">✨</span>
                                </div>
                                <h3 className="solution-card-title">UI/UX Design</h3>
                                <p className="solution-card-description">
                                    User-centric interfaces with intuitive navigation and engaging interactions
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Performance */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚡</span>
                                </div>
                                <h3 className="solution-card-title">Performance</h3>
                                <p className="solution-card-description">
                                    Lightning-fast loading speeds and optimized user experience
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* SEO Ready */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card highlighted">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">🎯</span>
                                </div>
                                <h3 className="solution-card-title">SEO Ready</h3>
                                <p className="solution-card-description">
                                    Built-in SEO best practices to improve your search engine visibility
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>

                        {/* Easy Management */}
                        <div className="col-lg-4 col-md-6">
                            <div className="design-solution-card">
                                <div className="solution-icon-wrapper">
                                    <span className="solution-icon">⚙️</span>
                                </div>
                                <h3 className="solution-card-title">Easy Management</h3>
                                <p className="solution-card-description">
                                    User-friendly content management systems for effortless updates
                                </p>
                                <a href="#" className="solution-learn-more">
                                    Learn More →
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-5">
                        <button className="btn-start-project">
                            Start Your Project →
                        </button>
                    </div>
                </div>
            </section>

            {/* Bespoke Software Solutions */}
            {/* <section className="bespoke-section py-5">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <h2 className="section-main-title mb-4">
                                Staff Augmentation Services
                            </h2>
                            <p className="section-description"><strong>Scale Your Team with Top Tech Talent, On-Demand</strong></p>


                            <p className="section-description">
                                At Gemperts, we provide flexible and reliable IT staff augmentation services that help you extend your team with skilled professionals - exactly when and where you need them. Whether you’re filling a talent gap, speeding up project delivery, or seeking niche expertise in AI, cloud, or full-stack development, our engineers integrate seamlessly with your in-house team.
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="bespoke-image-wrapper">
                                <img
                                    src="https://gempertsindia.com/wp-content/uploads/2025/07/staff-agumentation.jpg"
                                    alt="Bespoke Software Solutions"
                                    className="img-fluid rounded"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
        </>
    );
};

export default WebsiteDevelopment;
